import { FC } from 'react';
import styled, { keyframes } from 'styled-components';

const DealsheetErrorPage: FC = () => {
  return (
    <ErrorPage data-testid='error-page'>
      <GearIcon />
      <ErrorMessage>The Robot is hard at work.</ErrorMessage>
      <ErrorSubtitle>
        Unable to load information at this time. Please try again later.
      </ErrorSubtitle>
    </ErrorPage>
  );
};

const spin = keyframes`
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
`;

const GearIcon = styled.div`
  font-size: 150px;
  animation: ${spin} 5s linear infinite;
  transform-origin: center;
  &:before {
    font-family: 'icomoon';
    content: '\\e904';
    color: #999;
    display: inline-block;
    font-style: normal;
    font-size: inherit;
    text-rendering: auto;
    -webkit-font-smoothing: antialiased;
    margin-top: 20px;
  }
`;

const ErrorPage = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  height: 100vh;
  text-align: center;
`;

const ErrorMessage = styled.h1`
  font-size: 30px;
  margin-bottom: 10px;
  margin-top: -18px;
  font-weight: 600;
`;

const ErrorSubtitle = styled.p`
  font-size: 20px;
`;

export default DealsheetErrorPage;
